var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "85px",
    height: "85px",
    viewBox: "0 0 85 85",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Envelope_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Envelope_icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "envback_blue",
    transform: "translate(2.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.666634,0.584425244 C30.3878339,0.584425244 4.00049253,1.21960316 4.00049253,1.21960316 C1.79108151,1.2707086 0,3.09932299 0,5.31214742 L0,49.6716229 C0,51.8807672 1.7977397,53.6716326 4.00107193,53.6716326 L77.5221674,53.6716326 C79.7318984,53.6716326 81.5232393,51.8844473 81.5232393,49.6716229 L81.5232393,5.31214742 C81.5232393,3.10300307 79.7423101,1.26661606 77.5248995,1.21133473 C77.5248995,1.21133473 53.6754245,0.584425244 42.666634,0.584425244 Z",
    id: "front",
    stroke: "#AFC0D3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.666634,25.8856301 C30.3878339,25.8856301 3.14569775,3.78084951 3.14569775,3.78084951 C1.40837686,2.41741765 0,3.09932299 0,5.31214742 L0,49.6716229 C0,51.8807672 1.7977397,53.6716326 4.00107193,53.6716326 L77.5221674,53.6716326 C79.7318984,53.6716326 81.5232393,51.8844473 81.5232393,49.6716229 L81.5232393,5.31214742 C81.5232393,3.10300307 80.1735901,2.48083676 78.4784605,3.91866745 C78.4784605,3.91866745 53.6754245,25.8856301 42.666634,25.8856301 Z",
    id: "back",
    stroke: "#AFC0D3",
    fill: "#CDF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0091885,1.9084491 C29.7303885,1.9084491 3.34304705,2.54362701 3.34304705,2.54362701 C1.13363604,2.59473245 1.12827329,2.73453385 3.33751267,2.85623716 L72.1634233,6.64774145 C74.3697778,6.76928582 76.3329123,8.65219254 76.5476137,10.8472659 L80.4765616,51.0162075 C80.6915286,53.2139964 80.8657938,53.2084712 80.8657938,50.9956467 L80.8657938,6.63617128 C80.8657938,4.42702693 79.0848646,2.59063992 76.8674541,2.53535858 C76.8674541,2.53535858 53.017979,1.9084491 42.0091885,1.9084491 Z",
    id: "gloss",
    fill: "#FFFFFF",
    opacity: 0.626340951,
    transform: "translate(40.874364, 27.676455) scale(1, -1) translate(-40.874364, -27.676455) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.70d7e1aa45d6b9138e91bd62ec7fc53e.svg";
export { ForwardRef as ReactComponent };